$(document).ready(function(){
	
	//
	$('select.autocomplete').selectToAutocomplete();
	
	$('body').on('focus', 'input.autocomplete', function(){
		
		if($(this).val() == "Town or City")
		{
			$(this).val("");
		}
		
	});
	
	$('body').on('change keyup ready focus', 'input.autocomplete', function(){
		
		if($(this).val())
		{
			$(this).addClass('filled');
		}
		else
		{
			$(this).removeClass('filled');
		}
		
	});		

	//
	$('form').keypress(function(e) {
		
	    if(e.which == 13)
	    {

	      if( !$(e.target).hasClass('wysiwyg') && !$(e.target).is('textarea') )
	      {	    	
		      $(this).find('button').not('.file button, .files button, .mce-tinymce button').trigger('click');
		      return false;
		  }
		  
	    }
	    
	});	

	$.fn.checkRequiredFields = function(){
	
		form = this;
	
		msg = "";
	
		//check required fields
		form.find('.required').each(function(){
			
			placeholder = $(this).attr('placeholder');		
			
			if( $(this).is('select') )
			{
				value = $(this).find(':selected').val();
			}
			else if( $(this).attr('type') == "checkbox" )
			{
				placeholder = $(this).closest('label').find('span').text();
				if( $(this).is(':checked') )
				{
					value = true;
				}
				else
				{
					value = false;
				}
			}
			else
			{
				value = $(this).val();				
			}
						
			if(!value && ((($(this).is(':visible') || $(this).attr('type') == "hidden") && $(this).parent().is(':visible') ) || ($(this).hasClass('autocomplete') && $(this).parent().is(':visible')) || ( $(this).attr('type') == "checkbox") ) )
			{										
				if($(this).attr('name') == 'files_container')
				{
					wrapper = $(this).closest('div.file');
					
					if(wrapper.find('ul > li').size() == 0)
					{				
						msg += "<li>" + placeholder + " appears to be empty.</li>";
					}			
				}
				else
				{				
					msg += "<li>" + placeholder + " appears to be empty.</li>";
				}
			}			
			
		});	
		
		if(msg != "")
		{
			valid = false;
		}	
		
		return msg;	
	}
	
	
	$.fn.serializeObject = function()
	{
	    var o = {};
	    var a = this.serializeArray();
	    $.each(a, function() {
	        if (o[this.name] !== undefined) {
	            if (!o[this.name].push) {
	                o[this.name] = [o[this.name]];
	            }
	            o[this.name].push(this.value || '');
	        } else {
	            o[this.name] = this.value || '';
	        }
	    });
	    return o;
	};		

});
